import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Row } from 'react-bootstrap';
import Badge from 'components/base/Badge';

interface CrmStatCardProps {
  icon: IconProp;
  color: string;
  label: string;
  label2: string;
  label3: string;
  label4: string;
  title: string;
  value: number;
  value2: number;
  value3: number;
  value4: number;
}

const UserKPICard = ({
  icon,
  color,
  label,
  label2,
  label3,
  label4,
  title,
  value,
  value2,
  value3,
  value4
}: CrmStatCardProps) => {
  return (
    <Card className="h-100" style={{ minWidth: '16rem' }}>
      <Card.Body className="p-3 pt-0">
        <Row className="mb-3 border-bottom">
          <Col
            className="d-flex align-items-center"
            xs={7}
            sm={7}
            md={7}
            xl={7}
            xxl={8}
          >
            <div className={`d-flex pt-1`}>
              <FontAwesomeIcon
                icon={icon}
                className={`text-${color} fs-6 z-1 ms-2`}
              />
            </div>
            <p className="text-body-tertiary fs-10 mb-0 ms-2 mt-2 lh-1">
              {label} <br />
              <span className="p-0 fs-8 fw-bold lh-1 text-body-emphasis">
                {title}
              </span>
            </p>
          </Col>
          <Col
            className={`text-${color} mt-2 fs-6 fw-bold mb-0 pt-1 text-end`}
            xs={5}
            sm={5}
            md={5}
            xl={5}
            xxl={4}
          >
            {value}
          </Col>
        </Row>
        <Row className="mb-0 mt-0">
          <Col>
            <p className="text-body-tertiary fs-9 mb-0 text-end">
              {label2}
              <span className="fs-8">
                <Badge bg="primary" variant="phoenix">
                  {value2}
                </Badge>
              </span>
            </p>
          </Col>
        </Row>
        <Row className="mb-0 mt-0">
          <Col>
            <p className="text-body-tertiary fs-9 mb-0 text-end">
              {label3}
              <span className="fs-8">
                <Badge bg="primary" variant="phoenix">
                  {value3}
                </Badge>
              </span>
            </p>
          </Col>
        </Row>
        <Row className="mb-0 mt-0">
          <Col>
            <p className="text-body-tertiary fs-9 mb-0 text-end">
              {label4}
              <span className="fs-8">
                <Badge bg="primary" variant="phoenix">
                  {value4}
                </Badge>
              </span>
            </p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default UserKPICard;
